import { Routes } from '@angular/router';
import { frontRoutes } from 'src/app/front/models/front-routes';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('src/app/front/views/layout/layout.component').then(module => module.LayoutComponent),
        loadChildren: () => import('src/app/front/models/front-routes').then(m => m.frontRoutes),
        data: {
            children: frontRoutes
        }
    },
    {
        path: '**',
        redirectTo: ''
    },
];
